import { ReactNode, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { RootState } from "../../redux/store";
import { Button, LogoIcon, UserIcon } from "../../components";
import useOnClickOutside from "../../utils/useOnClickOutside";
import { userType } from "../../slices/userType";
import "./UserManagementContainer.scss";
import "../../assets/toastify.scss";

type UserManagementContainerProps = {
  children: ReactNode;
  showFullName?: boolean;
};

export const UserManagementContainer = ({ children, showFullName = false }: UserManagementContainerProps) => {
  const fullName = useSelector((state: RootState) => state.user.user.fullName);
  const loggedInUserType = useSelector((state: RootState) => state.auth.decodedToken.userType);
  const [isActive, setIsActive] = useState<boolean>(false);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const dropdownRef = useRef<HTMLDivElement>(null);
  const onOutsideClickHandler = () => {
    setIsActive(false);
  };

  useOnClickOutside(dropdownRef, onOutsideClickHandler);

  return (
    <div className="user-management-wrapper">
      <div ref={dropdownRef}>
        {showFullName ? (
          <header>
            <div className="menu-wrapper">
              <LogoIcon className="logo-icon" />
              <div className="full-name"> {fullName} </div>
            </div>
            {loggedInUserType !== userType.SSO && (
              <div className="content">
                <UserIcon
                  onClick={() => setIsActive(!isActive)}
                  className={`${isActive ? "user-icon active" : "user-icon"}`}
                />
              </div>
            )}
          </header>
        ) : (
          <header>
            <span className="logo-wrapper">
              <LogoIcon className="logo-icon" />
              {t("userManagement")}
            </span>
            {loggedInUserType !== userType.SSO && (
              <UserIcon
                onClick={() => setIsActive(!isActive)}
                className={`${isActive ? "user-icon active" : "user-icon"}`}
              />
            )}
          </header>
        )}
        <nav className={`menu ${isActive ? "active" : "inactive"}`}>
          <Button
            className="button-logout"
            type="button"
            lKey={"logout"}
            isDisabled={false}
            onClick={() => navigate("/logout")}
          />
        </nav>
      </div>
      <div className="user-management-wrapper-items">{children}</div>
    </div>
  );
};
